import React from "react";
import ViewTemplate from "./ViewTemplate";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import "./ViewGrid.css";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: blue[700],
    },
    primary: {
      main: blue[800],
    },
  },
  typography: {
    fontSize: 15,
  },
});

function ViewGrid({ server, replicaid, viewname, search, select, deletion, expand, grouping }) {
  return (
    <ThemeProvider theme={theme}>
      <div className="webapp">
        <ViewTemplate
          replicaid={replicaid}
          viewname={viewname}
          server={server}
          search={search}
          select={select}
          deletion={deletion}
          expand={expand}
          grouping={grouping}
        />
      </div>
    </ThemeProvider>
  );
}

export default ViewGrid;
